import type { JSX } from "react";
import styled from "styled-components";
import { StandardPadding } from "../components/templates/StandardPadding";
import { Spacer } from "../components/templates/Spacer";
import dynamic from "next/dynamic";

const Page = dynamic(() => import("../components/templates/Page").then((_) => _.Page));

export default function Blank(): JSX.Element {
  return (
    <Page
      hero={
        <Padding>
          <Spacer height="46rem" />
        </Padding>
      }
    />
  );
}

const Padding = styled(StandardPadding)`
  position: relative;
  max-width: 80rem;
  margin: 0 auto;
  text-align: center;
`;
